import styled from 'styled-components';

export default styled.p`
  --text-primary: var(--oh-hi-dark);
  --text-secondary: var(--sharkbait-ooh-la-la);
  --text-tertiary: var(--dirty-water);

  margin: 0;
  color: var(--text-primary);
  line-height: 1.5em;
  ${props => props.secondary && 'color: var(--text-secondary)'};
  ${props => props.bold && 'font-weight: var(--bold)'};
`;
